import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AlertController, IonContent, IonHeader, IonItem, IonTitle, IonToggle, IonToolbar, ModalController } from '@ionic/angular/standalone';
import { SexyModule } from "@qid/sexy";
import { AvatarRoundComponent, SuperButtonComponent } from "@qid/super";
import { OrganisationRelationship } from "../../model/organisation-relationship.model";
import { OrganisationRelationshipService } from "../../services/organisation-relationship.service";


@Component({
  selector: 'edit-organisation-relationship-page',
  templateUrl: './edit-organisation-relationship-page.component.html',
  styleUrls: ['./edit-organisation-relationship-page.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SexyModule,
    SuperButtonComponent,
    AvatarRoundComponent,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonItem,
    IonToggle
  ]
})
export class EditOrganisationRelationshipPage {

  orgRelationship: OrganisationRelationship = new OrganisationRelationship();

  constructor(private orgRelationshipService: OrganisationRelationshipService,
    private modalController: ModalController,
    private alertController: AlertController,
  ) {

  }

  showAlert = () => {
    this.alertController.create({
      header: 'Alert',
      message: `Are you sure you want to remove relationship from ${this.orgRelationship?.parentOrg?.name} ?`,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
        },
        {
          text: 'OK',
          handler: () => {
            this.removeRelation();
          },
        },
      ],
    }).then(alert => {
      alert.present();
    });
  };


  removeRelation = async () => {
    await this.orgRelationshipService.delete(this.orgRelationship._id)
    this.modalController.dismiss({ deleted: true })
  }

}
